<script>
import { layoutComputed } from "@/state/helpers";
import mushroom from "cem-probe-api";
import { listMenu } from "../stores/ListMenu";
import { abortAPI } from "@/stores/abortAPI";
import noneIconMenu from "../assets/icon/none-icon-menu.svg";
import MethodService from "../service/MethodService";
import { getSystemType, getCurrentPid } from "@/utils/systemType";
import { useRoute } from "vue-router";
import { langWeb } from "../stores/lang";
import { Filter, Sort, Project } from "mushroomjs";
const storeListMenu = listMenu();
const storeAbortAPI = abortAPI();
export default {
  data() {
    return {
      loadingService: true,
      settings: {
        minScrollbarLength: 60,
      },
      menuAPI: [],
      menuUsecasesAPI: [],
      roles: "",
      primaryLink: localStorage.urlPrimary,
      currentSystemType: getSystemType(),
      isHaveConfigMenuServiceId: false,
      srcIconMenuConfigService: null,
      nameMenuConfigService: null,
      idMenuConfigService: null,
      listMenuConfigService: [],
      listMenu: [],
      route: useRoute(),
      lang_web: langWeb(),
      pid: getCurrentPid(),
      pidSummary: window.localStorage.getItem("pid_summary") || "",
      userRegionCodes: [],
    };
  },
  computed: {
    ...layoutComputed,
    layoutType: {
      get() {
        return this.$store ? this.$store.state.layout.layoutType : {};
      },
    },
  },

  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
    "lang_web.showLang": {
      handler: "onChangeLang",
      immediate: true,
      deep: true,
    },
  },

  // async created() {
  //   this.menuAPI = storeListMenu.getListMenuService();
  //   this.menuUsecasesAPI = storeListMenu.getListMenuUsecases();
  // },

  async mounted() {
    const response = JSON.parse(localStorage.getItem("userInfo") || "{}");
    this.roles = response?.result?.roles || [];
    // Lấy thêm role động từ API user_role_dynamics
    await this.loadDynamicRoles();
    this.fetchUserRegions();
    await this.fetchSummaryProbeIdIfNeeded();
    this.getMenu();
    await storeListMenu.getListMenuService();
    await storeListMenu.getListMenuUsecases();
    this.menuAPI = storeListMenu.showListMenuService;
    this.menuUsecasesAPI = storeListMenu.showListMenuUsecases;
    // lấy cấu hình xem có menu service id không
    const resCauHinhMenuService = await mushroom.system_config.listAsync({
      fields: "id,key,value,is_public",
      filters: this.roles.includes("Admin")
        ? ["key=menu_service_id", "is_public=true"]
        : ["key=menu_service_id"],
    });
    if (resCauHinhMenuService.result?.length > 0) {
      this.idMenuConfigService = resCauHinhMenuService.result[0].value;
      this.isHaveConfigMenuServiceId = true;
      const arrayIds = resCauHinhMenuService.result[0].value.split(",");
      const resMenuConfigService = arrayIds.map((x) =>
        mushroom.service.findByIdAsync({
          id: x,
        }),
      );
      await Promise.allSettled(resMenuConfigService).then((data) => {
        data?.forEach((item) => {
          if (item.status === "fulfilled") {
            this.listMenuConfigService.push({
              name: item.value.result.name || item.value.result.fullname,
              id: item.value.result.id,
              srcAvatar: item.value.result.avatar_id
                ? mushroom.$file.linkBuilder.thumb
                    .id(item.value.result.avatar_id)
                    .clip(20, 20, "center")
                    .build()
                : null,
            });
          }
        });
      });
    } else {
      this.isHaveConfigMenuServiceId = false;
      this.srcIconMenuConfigService = null;
    }
    if (document.querySelectorAll(".navbar-nav .collapse")) {
      let collapses = document.querySelectorAll(".navbar-nav .collapse");
      collapses.forEach((collapse) => {
        // Hide sibling collapses on `show.bs.collapse`
        collapse.addEventListener("show.bs.collapse", (e) => {
          e.stopPropagation();
          let closestCollapse = collapse.parentElement.closest(".collapse");
          if (closestCollapse) {
            let siblingCollapses =
              closestCollapse.querySelectorAll(".collapse");
            siblingCollapses.forEach((siblingCollapse) => {
              if (siblingCollapse.classList.contains("show")) {
                let aChild = siblingCollapse.parentNode.firstChild;
                if (aChild.hasAttribute("aria-expanded")) {
                  aChild.setAttribute("aria-expanded", "false");
                }
                siblingCollapse.classList.remove("show");
              }
            });
          } else {
            let getSiblings = (elem) => {
              // Setup siblings array and get the first sibling
              let siblings = [];
              let sibling = elem.parentNode.firstChild;
              // Loop through each sibling and push to the array
              while (sibling) {
                if (sibling.nodeType === 1 && sibling !== elem) {
                  siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
              }
              return siblings;
            };
            let siblings = getSiblings(collapse.parentElement);
            siblings.forEach((item) => {
              if (item.childNodes.length > 2)
                item.firstElementChild.setAttribute("aria-expanded", "false");
              let ids = item.querySelectorAll("*[id]");
              ids.forEach((item1) => {
                // let aChild = item1.parentNode.firstChild;
                // if (aChild?.hasAttribute("aria-expanded")) {
                //   aChild.setAttribute("aria-expanded", "false");
                // }
                item1.classList.remove("show");
                if (item1.childNodes.length > 2) {
                  let val = item1.querySelectorAll("ul li a");

                  val.forEach((subitem) => {
                    if (subitem.hasAttribute("aria-expanded"))
                      subitem.setAttribute("aria-expanded", "false");
                  });
                }
              });
            });
          }
        });

        // Hide nested collapses on `hide.bs.collapse`
        collapse.addEventListener("hide.bs.collapse", (e) => {
          e.stopPropagation();
          let childCollapses = collapse.querySelectorAll(".collapse");
          childCollapses.forEach((childCollapse) => {
            let childCollapseInstance = childCollapse;
            childCollapseInstance.hide();
          });
        });
      });
    }
  },

  methods: {
    async fetchSummaryProbeIdIfNeeded() {
      const pidSummary = window.localStorage.getItem("pid_summary");
      if (pidSummary) {
        this.pidSummary = pidSummary;
        return;
      }
      try {
        const { result } = await mushroom.probe.get_probe_summary_infoAsync({});
        if (result) {
          this.pidSummary = result.id;
          window.localStorage.setItem("pid_summary", this.pidSummary);
        }
      } catch (e) {
        console.error("Lỗi lấy phân hệ summary: %o", e);
      }
    },
    async loadDynamicRoles() {
      try {
        const response = await mushroom.user_role_dynamic.getAllAsync({
          fields: "id,name",
        });
        if (response.result) {
          response.result.forEach((item) => {
            if (item.name && !this.roles.includes(item.name)) {
              this.roles.push(item.name);
            }
          });
        }
      } catch (e) {
        console.error("Có lỗi khi lấy role động: %o", e);
      }
    },
    async fetchUserRegions() {
      try {
        const regionUserRes = await mushroom.region_user.getAllAsync(
          {},
          { preferRole: "User|NoneWebGUI" },
        );
        if (regionUserRes.result && regionUserRes.result.length > 0) {
          const regionIds = regionUserRes.result.map((item) => item.region_id);
          const regionRes = await mushroom.region.getAllAsync({
            filters: Filter.in("id", regionIds).build(),
          });
          if (regionRes.result) {
            this.userRegionCodes = regionRes.result
              .filter((region) => region.code)
              .map((region) => region.code);
          }
        }
      } catch (e) {
        console.error("Có lỗi khi lấy vùng miền user: %o", e);
      }
    },
    isMonitorMenuVisible(link) {
      if (!link) return true;
      const match = link.match(/^\/monitor\?p_region=(.+)$/);
      if (!match) return true;
      const regionCode = match[1];
      return this.userRegionCodes.includes(regionCode);
    },
    filterMenuByRoles(menuList) {
      if (!menuList || !Array.isArray(menuList)) return [];
      return menuList
        .filter((menu) => {
          if (!menu.roles || menu.roles.length === 0) return true;
          return menu.roles.some((role) => this.roles.includes(role));
        })
        .map((menu) => {
          if (menu.children && menu.children.length > 0) {
            menu.children = menu.children.filter((child) => {
              if (!child.roles || child.roles.length === 0) return true;
              return child.roles.some((role) => this.roles.includes(role));
            });
          }
          return menu;
        });
    },
    onRoutechange(ele) {
      this.initActiveMenu(ele.path);
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition =
          document.getElementsByClassName("mm-active")[0].offsetTop;
        if (currentPosition > 500)
          if (this.$refs.isSimplebar)
            this.$refs.isSimplebar.value.getScrollElement().scrollTop =
              currentPosition + 300;
      }
      this.menuAPI = storeListMenu.showListMenuService;
      this.menuUsecasesAPI = storeListMenu.showListMenuUsecases;
    },

    initActiveMenu(ele) {
      setTimeout(() => {
        const menuTree = this.listMenu.find(
          (menu) =>
            menu.children.length > 0 &&
            menu.children.map((item) => item.link).includes(ele),
        );

        if (document.querySelector("#navbar-nav")) {
          let a = document
            .querySelector("#navbar-nav")
            .querySelector('[href="#a' + menuTree?.id + '"]');
          if (a) {
            let b = document
              .querySelector("#navbar-nav")
              .querySelector('[href="#a' + menuTree?.id + '"] + div');
            a.classList.add("active");
            if (b) {
              b.classList.add("show");
              b.parentElement.children[0].classList.add("active");
              b.parentElement.children[0].setAttribute("aria-expanded", "true");
              if (b.parentElement.closest(".collapse.menu-dropdown")) {
                b.parentElement.closest(".collapse").classList.add("show");
                if (b.parentElement.closest(".collapse").previousElementSibling)
                  b.parentElement
                    .closest(".collapse")
                    .previousElementSibling.classList.add("active");
              }
            }
          }
        }
      });
    },
    sanitizedLinkPrimary() {
      return MethodService.purifyUrl(this.primaryLink + "menu/list-menu");
    },
    sanitizedLinkMenu(textLink) {
      return MethodService.purifyUrl("#a" + textLink);
    },
    async getNumberMaxDynamic() {
      try {
        const { result } = await mushroom.system_config.listAsync({
          filters: Filter.eq("key", "max_dynamic_service_health").build(),
        });
        return result[0]?.value || 5;
      } catch (error) {
        console.error("Fetch max dynamic error:", error);
        return 5;
      }
    },
    async getMenu() {
      const maxDynamic = await this.getNumberMaxDynamic();
      const type = getSystemType();
      try {
        const response = await mushroom.menu.views.get_treeAsync(
          {
            domains: ["primary", type],
            currentDomain: type,
          },
          { clientCache: true },
        );
        // Filter menu theo roles (bao gồm cả role động)
        this.listMenu = this.filterMenuByRoles(response.result);

        let healthGroups = [];
        try {
          const { result } = await mushroom.service_health_group.listAsync({
            fields: Project.include("id", "name", "icon_id", "menu").build(),
            filters: Filter.eq("menu", true).build(),
            sort: Sort.ascending("name").build(),
            limit: maxDynamic,
          });
          if (result) healthGroups = result;
        } catch (error) {
          console.error("Fetch health groups error:", error);
        }

        if (this.listMenu && this.listMenu.length > 0) {
          this.listMenu.forEach((menu) => {
            if (menu.link === "/service-health") {
              if (!menu.children) menu.children = [];
              const hasSummary = menu.children.some(
                (child) =>
                  child.link === "/service-health" && !child.health_group_id,
              );
              if (!hasSummary) {
                menu.children.unshift({
                  id: menu.id,
                  link: "/service-health/" + menu.id + "?type=group-summary",
                  icon_id: menu.icon_id,
                  label: "Tổng hợp nhóm",
                  label_lang: {
                    en: "Group Summary",
                    vi: "Tổng hợp nhóm",
                  },
                  target_domain: "probe",
                });
              }

              healthGroups.forEach((group) => {
                const alreadyExists = menu.children.some(
                  (child) => child.health_group_id === group.id,
                );
                if (!alreadyExists) {
                  menu.children.push({
                    id: group.id,
                    health_group_id: group.id,
                    link: "/service-health/" + group.id + "?type=group",
                    label: group.name,
                    icon_id: group.icon_id,
                    label_lang: {
                      en: group.name,
                      vi: group.name,
                    },
                    target_domain: "probe",
                  });
                }
              });
            }
          });
        }

        this.initActiveMenu(window.location.pathname);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    setLink(link) {
      if (link === "#") return "/";
      if (typeof link === "string" && link.startsWith("/service-health")) {
        const query = {};
        const [path, queryString] = link.split("?");
        if (queryString) {
          const params = new URLSearchParams(queryString);
          params.forEach((v, k) => {
            query[k] = v;
          });
        }
        return {
          path: path,
          query: query,
        };
      }
      return link;
    },

    buildCemTicketEntryLink(link) {
      const token = window.localStorage.getItem(
        "mushroom.tokens[" + mushroom.$using() + "]",
      );
      const targetUrl = new URL(link);
      if (token) targetUrl.searchParams.set("access_token", token);
      targetUrl.searchParams.set(
        "urlPrimary",
        localStorage.getItem("urlPrimary") || "",
      );
      targetUrl.searchParams.set("lang", this.lang_web.showLang || "vi");
      return MethodService.purifyUrl(targetUrl.toString());
    },

    setLinkCrossDomain(targetDomain, link, label = "") {
      // Xác định baseUrl theo phân hệ đích
      let baseUrl = "";
      if (targetDomain === "primary") {
        baseUrl = this.primaryLink || "";
      } else {
        baseUrl = localStorage.getItem("url_" + targetDomain) || "";
        if (!baseUrl && targetDomain === this.currentSystemType) {
          baseUrl = window.location.origin + "/";
        }
      }
      if (!baseUrl) return "#";

      // Build params chung
      const token = window.localStorage.getItem(
        "mushroom.tokens[" + mushroom.$using() + "]",
      );
      const params = new URLSearchParams({
        pid_probe: window.localStorage.getItem("pid_probe") || "",
        pid_summary: this.pidSummary || "",
        url_probe: localStorage.getItem("url_probe") || "",
        url_summary: localStorage.getItem("url_summary") || "",
        urlPrimary: localStorage.getItem("urlPrimary") || "",
        lang: this.lang_web.showLang || "vi",
        system_type:
          targetDomain === "primary" ? this.currentSystemType : targetDomain,
        type_login: getSystemType(),
      });
      if (token) params.set("access_token", token);

      // Primary
      if (targetDomain === "primary") {
        if (/^https?:\/\//i.test(link || "")) {
          return this.buildCemTicketEntryLink(link);
        }
        const textLink =
          link === "#" || !link ? baseUrl : baseUrl + link.replace(/^\//, "");
        return MethodService.purifyUrl(textLink);
      }

      // Cross-domain: build entry.html với menu path
      if (link && link !== "#") {
        const menu = /^https?:\/\//i.test(link)
          ? new URL(link).pathname + new URL(link).search + new URL(link).hash
          : link;
        params.set("menu", menu);
      }
      if (label) params.set("summary_name", label);

      return MethodService.purifyUrl(
        baseUrl + "entry.html?" + params.toString(),
      );
    },

    setIcon(iconId) {
      if (iconId) return MethodService.thumbIcon(iconId, 32);
      return noneIconMenu;
    },

    getMenuLabel(menuItem) {
      if (!menuItem) return "";
      const lang = this.lang_web.showLang;
      if (
        menuItem.label_lang?.[lang] &&
        menuItem.label_lang[lang].trim() !== ""
      ) {
        return menuItem.label_lang[lang];
      }
      return menuItem.label || "";
    },

    changeMenu() {
      storeAbortAPI.deleteAbort();
    },
    logViewMenu(id, link, target, summaryName = "") {
      mushroom.menu
        .log_view_menuAsync({
          body: {
            menu_id: id,
            probe_id: this.pid,
          },
        })
        .catch((error) => {
          console.warn("Không thể log view cho menu này:", id, error);
        });

      if (target && target !== this.currentSystemType) {
        window.location.href = this.setLinkCrossDomain(
          target,
          link,
          summaryName,
        );
      } else {
        const domain = target || this.currentSystemType;
        window.localStorage.setItem("system_type", domain);
        if (domain === "summary" && summaryName) {
          window.localStorage.setItem("summaryName", summaryName);
        }
        this.$router.push(this.setLink(link));
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <ul class="navbar-nav h-100" id="navbar-nav">
      <!-- menu động -->
      <li
        class="nav-item"
        v-for="menu in listMenu"
        :key="menu.id"
        v-show="isMonitorMenuVisible(menu.link)"
      >
        <template v-if="menu.children.length > 0">
          <a
            class="nav-link menu-link"
            :href="sanitizedLinkMenu(menu.id)"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="sidebarMultilevel"
          >
            <img
              :src="setIcon(menu?.icon_id)"
              alt="icon"
              style="width: 18px; margin-right: 10px"
            />
            <span>{{
              menu?.label_lang?.[this.lang_web.showLang] &&
              menu.label_lang?.[this.lang_web.showLang].trim() !== ""
                ? menu.label_lang?.[this.lang_web.showLang]
                : menu.label
            }}</span>
          </a>
          <div class="collapse menu-dropdown" :id="`a${menu.id}`">
            <ul class="nav nav-sm flex-column">
              <li
                class="nav-item"
                v-for="item in menu.children"
                :key="item.id"
                v-show="isMonitorMenuVisible(item.link)"
                @click="changeMenu()"
              >
                <template
                  v-if="
                    item.target_domain &&
                    item.target_domain !== currentSystemType
                  "
                >
                  <a
                    class="nav-link"
                    :href="
                      setLinkCrossDomain(
                        item.target_domain,
                        item.link,
                        getMenuLabel(item),
                      )
                    "
                    data-key=""
                    @click.prevent="
                      logViewMenu(
                        item.id,
                        item.link,
                        item.target_domain,
                        getMenuLabel(item),
                      )
                    "
                  >
                    <img
                      :src="setIcon(item?.icon_id)"
                      alt="icon"
                      style="width: 18px; margin-right: 10px"
                    />
                    <span>{{
                      item?.label_lang?.[this.lang_web.showLang] &&
                      item.label_lang?.[this.lang_web.showLang].trim() !== ""
                        ? item.label_lang?.[this.lang_web.showLang]
                        : item?.label
                    }}</span>
                  </a>
                </template>
                <template v-else>
                  <router-link
                    :to="setLink(item.link)"
                    class="nav-link"
                    @click.prevent="
                      logViewMenu(
                        item.id,
                        item.link,
                        item.target_domain,
                        currentSystemType === 'summary'
                          ? getMenuLabel(item)
                          : getMenuLabel(menu),
                      )
                    "
                  >
                    <img
                      :src="setIcon(item?.icon_id)"
                      alt="icon"
                      style="width: 18px; margin-right: 10px"
                    />
                    <span>{{
                      item?.label_lang?.[this.lang_web.showLang] &&
                      item.label_lang?.[this.lang_web.showLang].trim() !== ""
                        ? item.label_lang?.[this.lang_web.showLang]
                        : item?.label
                    }}</span>
                  </router-link>
                </template>
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <template
            v-if="
              menu.target_domain && menu.target_domain !== currentSystemType
            "
          >
            <a
              :href="
                setLinkCrossDomain(
                  menu.target_domain,
                  menu.link,
                  getMenuLabel(menu),
                )
              "
              class="nav-link menu-link"
              data-key=""
              @click.prevent="
                logViewMenu(
                  menu.id,
                  menu.link,
                  menu.target_domain,
                  getMenuLabel(menu),
                )
              "
            >
              <img
                :src="setIcon(menu?.icon_id)"
                alt="icon"
                style="width: 18px; margin-right: 10px"
              />
              <span>{{
                menu?.label_lang?.[this.lang_web.showLang] &&
                menu.label_lang?.[this.lang_web.showLang].trim() !== ""
                  ? menu.label_lang?.[this.lang_web.showLang]
                  : menu.label
              }}</span>
            </a>
          </template>
          <template v-else>
            <router-link
              @click="changeMenu()"
              :to="menu.link"
              class="nav-link menu-link"
              :data-key="menu.id"
              @click.prevent="
                logViewMenu(
                  menu.id,
                  menu.link,
                  menu.target_domain,
                  getMenuLabel(menu),
                )
              "
            >
              <img
                :src="setIcon(menu?.icon_id)"
                alt="icon"
                style="width: 18px; margin-right: 10px"
              />
              <span>{{
                menu?.label_lang?.[this.lang_web.showLang] &&
                menu.label_lang?.[this.lang_web.showLang].trim() !== ""
                  ? menu.label_lang?.[this.lang_web.showLang]
                  : menu.label
              }}</span>
            </router-link>
          </template>
        </template>
      </li>

      <li class="nav-item" v-if="this.roles.includes('Admin')">
        <a
          class="nav-link menu-link"
          :href="sanitizedLinkPrimary()"
          data-key=""
          @click.prevent="
            logViewMenu('ConfigMenu', '/menu/list-menu', 'primary')
          "
        >
          <i class="ri-menu-add-line"></i>
          <span>{{ $t("t-config-menu") }}</span>
        </a>
      </li>
    </ul>
  </div>
  <!-- Sidebar -->
</template>
<style scoped>
.loading-container {
  height: 200px;
}
li {
  width: 100%;
}
span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
</style>
